export const serviceData = {
  'Mechanicals': {
    imageUrl: '/images/services/plumbing/plumbing3.webp',
    description: 'Comprehensive mechanical systems installation and maintenance. We handle all mechanical components of your home for optimal performance.',
    badgeText: 'Expert HVAC & Systems',
    features: [
      'HVAC system installation and repair',
      'Ductwork design and installation',
      'Mechanical room setup',
      'System maintenance and optimization',
      'Energy efficiency improvements'
    ]
  },
  'MEP': {
    imageUrl: '/images/services/plumbing/plumbing4.webp',
    description: 'Complete MEP (Mechanical, Electrical, Plumbing) services. We coordinate all building systems for seamless integration.',
    badgeText: 'Complete MEP Systems',
    features: [
      'Integrated system design',
      'Mechanical system coordination',
      'Electrical system planning',
      'Plumbing system integration',
      'Code compliance and inspection'
    ]
  },
  'Foundations': {
    imageUrl: '/images/services/Foundations/foundations1.webp',
    description: 'Expert foundation repair and installation services. We ensure your home has a solid, stable foundation that will last for decades.',
    badgeText: 'Solid Foundation Work',
    features: [
      'Foundation inspection and assessment',
      'Crack repair and sealing',
      'Waterproofing solutions',
      'Structural reinforcement',
      'Drainage system installation'
    ]
  },
  'Roofing': {
    imageUrl: '/images/services/roofing/roofing1.webp',
    description: 'Professional roofing services including repair, replacement, and maintenance. We work with all major roofing materials and styles.',
    badgeText: 'Professional Roofing',
    features: [
      'Shingle and tile installation',
      'Roof leak detection and repair',
      'Gutter installation and cleaning',
      'Skylight installation',
      'Roof ventilation systems'
    ]
  },
  'Kitchens': {
    imageUrl: '/images/services/kitchens/kitchens1.webp',
    description: 'Transform your kitchen into the heart of your home with our comprehensive kitchen remodeling services.',
    badgeText: 'Dream Kitchen Design',
    features: [
      'Custom cabinet design and installation',
      'Countertop installation',
      'Appliance integration',
      'Lighting and electrical work',
      'Plumbing and fixture installation'
    ]
  },
  'Bathrooms': {
    imageUrl: '/images/services/bathrooms/bathroom1.webp',
    description: 'Create your dream bathroom with our luxury bathroom remodeling services. From powder rooms to master suites.',
    badgeText: 'Luxury Bathroom Renovation',
    features: [
      'Custom tile work and design',
      'Vanity and cabinet installation',
      'Shower and tub installation',
      'Plumbing and electrical work',
      'Lighting and ventilation'
    ]
  },
  'Basements': {
    imageUrl: '/images/services/basements/basement1.webp',
    description: 'Transform your basement into usable living space with our professional basement finishing services.',
    badgeText: 'Basement Transformation',
    features: [
      'Waterproofing and moisture control',
      'Framing and drywall installation',
      'Flooring and ceiling work',
      'Electrical and plumbing rough-in',
      'HVAC and ventilation systems'
    ]
  },
  'Siding': {
    imageUrl: '/images/services/Siding/siding1.webp',
    description: 'Enhance your home\'s curb appeal and protection with our professional siding installation and repair services.',
    badgeText: 'Curb Appeal Enhancement',
    features: [
      'Vinyl, wood, and fiber cement siding',
      'Siding repair and replacement',
      'Trim and molding installation',
      'Insulation and weatherproofing',
      'Color consultation and design'
    ]
  },
  'Additions': {
    imageUrl: '/images/services/home-additions/home-additions1.webp',
    description: 'Expand your living space with our home addition services. We seamlessly integrate new spaces with your existing home.',
    badgeText: 'Seamless Home Expansion',
    features: [
      'Architectural design and planning',
      'Foundation and structural work',
      'Roofing and exterior finishing',
      'Interior finishing and trim',
      'Permit acquisition and compliance'
    ]
  },
  'Full Gut Rehabs': {
    imageUrl: '/images/services/Full Gut Rehab/full-gut-rehab1.webp',
    description: 'Complete home transformation with our full gut renovation services. We handle every aspect of your home remodel.',
    badgeText: 'Complete Home Transformation',
    features: [
      'Complete demolition and cleanup',
      'Structural modifications',
      'All trades coordination',
      'Custom design implementation',
      'Project management and timeline'
    ]
  },
  'Plumbing': {
    imageUrl: '/images/services/plumbing/plumbing1.webp',
    description: 'Professional plumbing services for all your home needs. From repairs to complete system installations.',
    badgeText: 'Expert Plumbing Solutions',
    features: [
      'Pipe repair and replacement',
      'Fixture installation and repair',
      'Water heater services',
      'Drain cleaning and repair',
      'Emergency plumbing services'
    ]
  },
  'Framing': {
    imageUrl: '/images/services/Framing/framing1.webp',
    description: 'Expert framing services for new construction, additions, and structural modifications.',
    badgeText: 'Precision Structural Framing',
    features: [
      'New construction framing',
      'Addition and renovation framing',
      'Structural beam installation',
      'Load-bearing wall modifications',
      'Code compliance and inspection'
    ]
  },
  'Cement': {
    imageUrl: '/images/services/home-cement/home-cement1.webp',
    description: 'Professional concrete and cement work for driveways, patios, foundations, and decorative applications.',
    badgeText: 'Professional Concrete Work',
    features: [
      'Driveway and walkway installation',
      'Patio and outdoor living spaces',
      'Foundation and footing work',
      'Decorative concrete finishes',
      'Repair and restoration services'
    ]
  },
  'Tile Work': {
    imageUrl: '/images/services/home-tiles/home-tiles1.webp',
    description: 'Expert tile installation and repair services for bathrooms, kitchens, floors, and decorative applications.',
    badgeText: 'Expert Tile Installation',
    features: [
      'Bathroom and kitchen tile installation',
      'Floor and wall tile work',
      'Mosaic and decorative tile designs',
      'Grout repair and replacement',
      'Tile cleaning and maintenance'
    ]
  },
  'HVAC': {
    imageUrl: '/images/services/HVAC/hvac1.webp',
    description: 'Complete heating, ventilation, and air conditioning services for optimal home comfort.',
    badgeText: 'Complete HVAC Solutions',
    features: [
      'Furnace and AC installation',
      'Ductwork design and installation',
      'System maintenance and repair',
      'Energy efficiency upgrades',
      'Indoor air quality solutions'
    ]
  },
  'Electrical': {
    imageUrl: '/images/services/Electrical/electrical1.webp',
    description: 'Licensed electrical services for all your home electrical needs. Safe, reliable, and up to code.',
    badgeText: 'Licensed Electrical Work',
    features: [
      'Wiring and outlet installation',
      'Lighting design and installation',
      'Panel upgrades and repairs',
      'Smart home integration',
      'Safety inspections and testing'
    ]
  },
  'Painting': {
    imageUrl: '/images/services/Paint/paint1.webp',
    description: 'Professional interior and exterior painting services. Quality workmanship with attention to detail.',
    badgeText: 'Professional Painting Services',
    features: [
      'Interior and exterior painting',
      'Color consultation and design',
      'Surface preparation and repair',
      'Specialty finishes and techniques',
      'Cleanup and protection'
    ]
  },
  'Drywall': {
    imageUrl: '/images/services/basements/basement2.webp',
    description: 'Expert drywall installation, repair, and finishing services for smooth, professional walls.',
    badgeText: 'Expert Drywall Finishing',
    features: [
      'Drywall installation and hanging',
      'Taping and mudding',
      'Texture matching and repair',
      'Sanding and finishing',
      'Priming and paint preparation'
    ]
  },
  'Windows & Doors': {
    imageUrl: '/images/services/Windows and doors/windows-and-doors1.webp',
    description: 'Energy-efficient window and door installation and replacement services.',
    badgeText: 'Energy-Efficient Windows & Doors',
    features: [
      'Window replacement and installation',
      'Door installation and repair',
      'Energy efficiency upgrades',
      'Hardware and trim installation',
      'Weatherproofing and sealing'
    ]
  },
  'Fences & Decks': {
    imageUrl: '/images/services/Fences and Decks/fences-and-decks1.webp',
    description: 'Custom fence and deck construction services to enhance your outdoor living space.',
    badgeText: 'Custom Outdoor Living Spaces',
    features: [
      'Custom deck design and construction',
      'Fence installation and repair',
      'Staining and sealing services',
      'Railings and safety features',
      'Maintenance and restoration'
    ]
  }
};

// Default data for services not in the main object
export const getServiceData = (serviceName) => {
  return serviceData[serviceName] || {
    imageUrl: '/images/services/roofing/roofing1.webp',
    description: `Professional ${serviceName.toLowerCase()} services. We provide expert workmanship and quality results for all your home improvement needs.`,
    badgeText: `Professional ${serviceName}`,
    features: [
      'Expert consultation and planning',
      'Quality materials and workmanship',
      'Professional installation',
      'Cleanup and project completion',
      'Warranty and follow-up service'
    ]
  };
};
